import { Box, Container, Grid, Typography } from "@material-ui/core";
import React, { Fragment, useEffect, useState } from "react";
import { formatDate } from "../utils/dateUtils";
import { FaAngleRight } from "react-icons/fa6";
export default function CampaignTabs({ data }) {
  const [currentTab, setCurrentTab] = useState<string>("first");

  function toggleTabs(tab) {
    setCurrentTab(tab);
  }
  useEffect(() => {
    if (data.informationList && data.informationList.length == 0) {
      setCurrentTab("second");
    }
  }, []);
  return (
    <Fragment>
      {data.campaignList && data.informationList && (
        <Fragment>
          {data.campaignList.length | data.informationList.length ? (
            <Box className="campaign-banner">
              <Container className="container">
                <Grid
                  container
                  className={
                    data.campaignList &&
                    data.campaignList.length > 0 &&
                    data.informationList &&
                    data.informationList.length > 0
                      ? "border notifications-row"
                      : "notifications-row"
                  }
                >
                  {data.informationList && data.informationList.length > 0 && (
                    <Grid item md>
                      <Typography component={"h4"}>お知らせ</Typography>
                      <div className="notifications">
                        {data.informationList.map((list, id) => (
                          <div className="notification" key={id}>
                            <Typography component={"span"}>
                              {formatDate(list.updateTime, true, "")}
                            </Typography>
                            <Typography>{list.content}</Typography>
                          </div>
                        ))}
                        {/* <button>
                          <FaAngleRight /> お知らせ一覧を見る{" "}
                        </button> */}
                      </div>
                    </Grid>
                  )}
                  {data.campaignList && data.campaignList.length > 0 && (
                    <Grid item md>
                      <Typography component={"h4"}>キャンペーン</Typography>
                      <div className="notifications">
                        {data.campaignList.map((list, id) => (
                          <div className="notification" key={id}>
                            <Typography component={"span"}>
                              {formatDate(list.updateTime, true, "")}
                            </Typography>
                            <Typography>{list.content}</Typography>
                          </div>
                        ))}
                        {/* <button>
                          <FaAngleRight /> お知らせ一覧を見る{" "}
                        </button> */}
                      </div>
                    </Grid>
                  )}
                </Grid>
              </Container>
            </Box>
          ) : (
            ""
          )}
        </Fragment>
      )}
    </Fragment>
  );
}
